// extracted by css-extract-rspack-plugin
export default {"bodyContainer":"src-domain-components-hardware-details-information-HardwareDetailsInformation-module__bodyContainer-LyDEis","sideContainer":"src-domain-components-hardware-details-information-HardwareDetailsInformation-module__sideContainer-plJACo"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"bodyContainer\":\"src-domain-components-hardware-details-information-HardwareDetailsInformation-module__bodyContainer-LyDEis\",\"sideContainer\":\"src-domain-components-hardware-details-information-HardwareDetailsInformation-module__sideContainer-plJACo\"}";
        // 1793705032587
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  